<template>
  <el-popover
      placement="bottom"
      :width="containerWith"
      trigger="click"
  >
    <template #reference>
      <div class="border border-boots border-radius-md cursor-pointer p-1 bg-white text-dark"  :class="container_class"  >

        <div v-if="loading" class="spinner-border spinner-border-sm m-0 " role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <div v-else class="d-flex justify-content-between align-items-center w-100 ">
          <div style="height: 22px;line-height: 22px;">
            <div v-if="result" class="d-flex justify-content-between align-items-center w-100 ">

              <span
                  v-for="(param, i) in getResultFroRenderLimitedKeys"
                  :key="param"
                  class="badge bg-primary cursor-pointer text-xxs p-1 d-flex justify-content-between align-items-center me-1"
                  @click.prevent="clickedToUtmElem(i)"
              >
                {{param}}: {{ getResultFroRender[param] }}
                  <el-icon v-if="canReset" class="ms-1"><CloseBold /></el-icon>
              </span>
              <span v-if="getResultFroRenderCount > 2" class="text-xxs">...</span>
            </div>
            <span v-else class="text-xs">{{$t("Components.EventSelector.Select")}}</span>
          </div>

          <i class="fas fa-angle-down"></i>
        </div>
      </div>
    </template>

    <div v-if="loading" class="d-flex justify-content-center align-items-center">
      <div class="spinner-border m-5" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-12 mb-3">
          <el-input
              v-model="searchInput"
              :placeholder='$t("Components.EventSelector.Search")'
              :prefix-icon="searchIcon"
          />
        </div>
      </div>

      <div class="mb-2">
        <ResourceSelector v-model="resource_keys" multiple />
      </div>

      <div class="row">
        <div class="col-12 border-start overflow-auto" style="height: 360px">
          <h5 class="text-xs text-uppercase text-monospace"></h5>

          <EmptyInfoBlock v-if="!data" />

          <el-tree
              v-else
              ref="utmTree"
              style="max-width: 600px"
              :props="data"
              :load="loadNode"
              node-key="key"
              :default-checked-keys=defaultCheckedKeys
              lazy
              show-checkbox
              @check-change="handleCheckChange"
              :check-strictly="true"
          />
        </div>
      </div>
    </div>



<!--    <el-tree-v2-->
<!--        style="max-width: 600px"-->
<!--        :data="data"-->
<!--        show-checkbox-->
<!--        :expand-on-click-node="false"-->
<!--    />-->
  </el-popover>
</template>

<script>
import { Search, CloseBold } from '@element-plus/icons-vue'
import DictionariesService from "@/helpers/api/dictionaries.service";
import ResourceSelector from "@/views/components/graspil/ResourceSelector.vue"
import EmptyInfoBlock from "@/views/components/EmptyInfoBlock.vue";
import {isArray} from "chart.js/helpers";

export default {
  name: "UtmField",
  components: {EmptyInfoBlock, ResourceSelector, CloseBold},
  props: {
    container_class: {
      type: String,
      default: null,
    },
    modelValue: {
      type: Array,
      default: null
    },
    canReset: {
      type: Boolean,
      default: false,
    },
    useKey: {
      type: String,
      default: 'id',
    },
    returnSimpleObj: {
      type: Boolean,
      default: false,
    },
    resourceKeys: {
      type: Array,
      default: null,
    },
    conditionPath: {
      type: String,
      default: null,
    }
  },
  data: function () {
    return {
      loading: false,
      containerWith: '400px',
      selectedItems: [],
      searchInput: null,
      data: {
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf',
      },
      resource_keys_local: null,
      result: null,
      utm_names: {
        param: {},
        value: {}
      },
      nodesCategories: {}
    }
  },
  computed: {
    getResultFroRender: function() {
      if (this.conditionPath) {
        const data = {}
        for (let entry of this.result || []) {
          data[entry.field] = entry.values.length ? entry.values.join(', ') : '*'
        }
        return data
      }
      if (this.returnSimpleObj) {
        let data = {}
        for (let item of this.result) {
          data = {...data, ...item}
        }
        return data
      } else {
        let items = {}
        for (let item in this.result.slice(1)) {
          items[item[1]] = this.getUtmNameForField(item[1], item[2])
        }
        return items
      }
    },
    getResultFroRenderCount: function() {
      const r = this.getResultFroRender || {}
      return Object.keys(r).length
    },
    getResultFroRenderLimitedKeys: function() {
      const r = this.getResultFroRender || {}
      return Object.keys(r).slice(0, 2)
    },
    defaultCheckedKeys: function() {
      if (!this.modelValue || this.conditionPath) {
        return []
      }
      const checkedKeys = []

      if (this.useKey === 'id') {
        for (let i in this.modelValue) {
          if (this.modelValue[i][0] === 'in') {
            for (let ids of this.modelValue[i][2]) {
              checkedKeys.push(this.modelValue[i][1] + '_' + ids)
            }
          }
        }
      } else {
        let level = 0
        for (let param in this.modelValue) {
          checkedKeys.push('param_' + this.useKey + '_' + level + '_' + param)

          if (isArray(this.modelValue[param])) {
            for (let value in this.modelValue[param]) {
              checkedKeys.push('value_' + this.useKey + '_' + level + '_' + value)
            }
          } else {
            checkedKeys.push('value_' + this.useKey + '_' + level + '_' + this.modelValue[param])
          }
        }
      }

      return checkedKeys
    },
    searchIcon() {
      return Search
    },
    resource_keys: {
      get: function() {
        if (this.resourceKeys) {
          return this.resourceKeys
        }
        if (this.resource_keys_local) {
          return this.resource_keys_local
        }
        return [this.$store.state.init.current_bot.key]
      },
      set: function(value) {
        this.resource_keys_local = value
      }
    }
  },
  methods: {
    clickedToUtmElem: function(i) {
      if (!this.canReset) {
        return
      }
      this.result.splice(i, 1)
      this.$emit('update:modelValue', this.result)
      this.$emit('change', this.result)
      this.handleCheckChange()
    },
    getUtmNameForField: function (field, ids) {
      let type = 'param'
      if (field.includes('value')) {
        type = 'value'
      }
      // else if (field.includes('param')) {
      //
      // }

      const names = []
      for (let id of ids) {
        names.push(this.utm_names[type][id] ) // ?? this.getUtmName(type, id)
      }
      return names
    },
    getUtmName: async function(type, id) {
      await this.loadNameUtm([{
        type, id
      }]).then(() => {
        return this.utm_names[type][id]
      })
    },
    loadNameUtm: async function(query) {
      if (!this.resource_keys) {
        return
      }
      this.loading = true
      const payload = {
        resource_keys: this.resource_keys,
        query: query
      }

      return DictionariesService.resolveUtm({}, payload).then(data => {
        for (let item of data) {
          this.utm_names[item.type][item.id] = item.name
        }
        this.loading = false
      })
    },
    handleCheckChange: function () {
      const nodes = this.$refs.utmTree.getCheckedNodes(false, true)

      if (!nodes.length) {
        this.result = null
        this.$emit('update:modelValue', null)
        this.$emit('change', null)
        return
      }

      if (this.conditionPath) {
        const grouped = {}
        for (let node of nodes) {
          const paramName = node.type === 'param' ? node.name : node.param_name
          if (!grouped[paramName]) {
            grouped[paramName] = new Set()
          }
          if (node.type === 'value') {
            grouped[paramName].add(node.name)
          }
        }

        this.result = Object.keys(grouped).map(field => ({field, values: [...grouped[field]]}))

        const condition = this.buildCondition()
        this.$emit('update:modelValue', condition)
        this.$emit('change', condition)
        return
      }

      if (this.returnSimpleObj) {

        let result = {}
        for (let node of nodes) {
          if (!result[node.mainCat]) {
            result[node.mainCat] = {}
          }

          if (node.type === 'param') {
            result[node.mainCat][node.name] = '*'
          } else {
            if (result[node.mainCat][node.param_name] && result[node.mainCat][node.param_name] !== '*') {
              result[node.mainCat][node.param_name].push(node.name)
            } else {
              result[node.mainCat][node.param_name] = [node.name]
            }
          }
        }
        this.result = []
        for (let key in result) {
          this.result.push(result[key])
        }

      } else {
        this.result = [
          'and'
        ]

        for (let node of nodes) {
          let search_index = this.searchFieldInResult(node.val.field)
          if (search_index === false) {
            this.result.push(
                ['in', node.val.field, [node.val.val]]
            )
          } else {
            this.result[search_index][2] = [...this.result[search_index][2], ...[node.val.val]]
          }
          this.utm_names[node.type][node.val.val] = node.name

        }
      }


      this.$emit('update:modelValue', this.result)
      this.$emit('change', this.result)
    },
    buildCondition: function () {
      if (!this.result || !this.result.length) {
        return null
      }
      const clauses = this.result.map(entry => {
        const path = `${this.conditionPath}.${entry.field}`
        if (!entry.values.length) {
          return ['!=', path, null]
        }
        if (entry.values.length === 1) {
          return ['=', path, entry.values[0]]
        }
        return ['in', path, entry.values]
      })
      return clauses.length === 1 ? clauses[0] : ['and', ...clauses]
    },
    parseCondition: function (condition) {
      if (!condition) {
        return null
      }
      const clauses = condition[0] === 'and' ? condition.slice(1) : [condition]
      const prefix = this.conditionPath + '.'
      const result = []

      for (let clause of clauses) {
        if (!Array.isArray(clause) || typeof clause[1] !== 'string' || !clause[1].startsWith(prefix)) {
          continue
        }
        const [op, path, value] = clause
        const field = path.slice(prefix.length)
        let values
        if (op === '!=' && value === null) {
          values = []
        } else if (op === 'in') {
          values = Array.isArray(value) ? value : [value]
        } else {
          values = [value]
        }
        result.push({field, values})
      }

      return result.length ? result : null
    },
    searchFieldInResult: function (field_name) {
      if (!this.result) {
        return false
      }
      for (let i in this.result) {
        if (this.result[i][0] !== undefined && this.result[i][0] === 'in' && this.result[i][1] === field_name) {
          return i
        }
      }
      return false
    },
    loadNode: function (node, resolve) {
      if (!this.resource_keys) {
        return
      }

      let level = node.level
      const typeValue = (level % 2 !== 1)
      if (typeValue) {
         level = level / 2
      } else {
         level = level / 2 - 0.5
      }

      const payload = {
        resource_keys: this.resource_keys,
        level: node.level,
        ...node.data.path
      }

      if (payload.level > 12) {
        payload.level = 12
      }

      let mainCat = null
      for (let key in payload) {
        if (key === 'resource_keys' || key === 'level') {
          continue
        }

        if (key.includes('param')) {
          mainCat = this.nodesCategories['param_' + payload[key]]
        }
        if (key.includes('value')) {
          mainCat = this.nodesCategories['value_' + payload[key]]
        }
      }

      return DictionariesService.getResourceUtm({}, payload).then(data => {

        const tree = []
        // let nextLevel = typeValue ? level : level + 1



        data.forEach(item => {
          if ((typeValue && !item['param_' + level + '_name']) || (!typeValue && !item['value_' + level + '_name'])) {
            return
          }

          if (level === 0 && Object.keys(payload).length === 2) {
            this.nodesCategories['param_' + item['param_' + level + '_id']] = item['param_' + level + '_id']
            mainCat = item['param_' + level + '_id']
          } else {
            if (typeValue) {
              this.nodesCategories['param_' + item['param_' + level + '_id']] = mainCat
            } else {
              this.nodesCategories['value_' + item['value_' + level + '_id']] = mainCat
            }
          }

          tree.push({
            name: typeValue ? item['param_' + level + '_name'] : item['value_' + level + '_name'],
            leaf: level === 5 ? true : false, // typeValue ? !item['value_' + nextLevel + '_id'] : !item['param_' + nextLevel + '_id'],
            path: this.getPath(item, level, typeValue),
            val: typeValue
                ? { field: 'param_id_' + level, val: item['param_' + level + '_id'] }
                : { field: 'value_id_' + level, val: item['value_' + level + '_id'] },
            key: typeValue ?  'param_' + this.useKey + '_' + level + '_' + item['param_' + level + '_' + this.useKey] : 'value_' + this.useKey + '_' + level + '_' + item['value_' + level + '_' + this.useKey],
            type: typeValue ? 'param' : 'value',
            param_name: typeValue ? null : item['param_' + level + '_name'] ?? null,
            level: level,
            mainCat: mainCat
          })
        })
        return resolve(tree)
      }).catch(e => {
        console.log(e)
      })
    },
    getPath: function (item, level, typeVal) {
      let i = 0
      const path = {}

      while (i <= level) {
        path['param_' + i + '_id'] = item['param_' + i + '_id']
        if (i === level) {
          if (!typeVal) {
            path['value_' + i + '_id'] = item['value_' + i + '_id']
          }
        } else {
          path['value_' + i + '_id'] = item['value_' + i + '_id']
        }

        i++
      }
      return path
    }
  },
  mounted() {
    if (this.conditionPath) {
      this.result = this.parseCondition(this.modelValue)
      return
    }

    if (this.modelValue) {
      this.result = this.modelValue

      if (this.useKey === 'name') {
        return
      }
      const query = []
      for (let item of this.modelValue) {
        if (item[0] !== 'in') {
          continue
        }
        for (let id of item[2]) {
          query.push({
            type: item[1].includes('value') ? 'value' : 'param',
            id: id
          })
        }
      }

      this.loadNameUtm(query)
    }
  }
}
</script>

<style scoped>

</style>